// =============================================================
// GSAP — tek noktadan plugin kaydı (mimari plan)
// =============================================================

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

let registered = false;

export function registerGsap(): void {
  if (registered) return;
  gsap.registerPlugin(ScrollTrigger);
  gsap.defaults({
    ease: "power2.out",
    duration: 0.6,
  });
  registered = true;
}

export { gsap, ScrollTrigger };